<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline">
    <mat-label i18n>Workflow form</mat-label>
    <mat-select id="workflow-id" formControlName="id">
      @for (option of workflowNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
